import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Modal } from '../../../../../components/Modal/Modal'
import { useAppSelector } from '../../../../../store/hooks'
import { selectAccountId } from '../../../../../store/auth/authSlice'
import { selectRoomSession } from '../../../../../store/meetingSummary/roomSession'
import { useRemoveAllocationContextUserMutation } from '../../../../../store/media/media'
import { User } from '../../../../../models/User'
import { getUserDisplayName } from '../../common/aifeatures/utils'

export interface RemoveParticipantModalProps {
  show: boolean
  user: User
  onCancel: () => void
  onSuccess: () => void
  polling?: boolean
}

export const RemoveParticipantModal: React.FC<RemoveParticipantModalProps> = ({ show, user, onCancel, onSuccess, polling }) => {
  const accountId = useAppSelector(selectAccountId)
  const roomSession = useAppSelector(selectRoomSession)
  const { roomId = '', id: sessionId = '' } = roomSession ?? {}
  const [removeAllocationContextUser, { isLoading: removingAllocationContextUser, isSuccess: removedAllocationContextUser, reset }] =
    useRemoveAllocationContextUserMutation()

  useEffect(() => {
    if (removedAllocationContextUser) {
      reset()
      onSuccess()
    }
  }, [removedAllocationContextUser, onSuccess, reset])

  const handleRemoveParticipant = () => {
    removeAllocationContextUser({
      accountId,
      roomId,
      sessionId,
      body: { userId: user.id },
    })
  }

  const displayName = getUserDisplayName(user)

  const body = (
    <Container className='d-flex flex-column gap-4'>
      <Row>
        <Col className='p-0'>
          <div className='paragraph-medium'>
            Do you want to remove <strong>{displayName}</strong> from this meeting?
          </div>
        </Col>
      </Row>
    </Container>
  )

  return (
    <Modal
      className='remove-participant-modal'
      show={show}
      onHide={onCancel}
      header={<h4>Remove Client</h4>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={handleRemoveParticipant}
      footerPrimaryActionTitle='Remove'
      footerPrimaryActionButtonVariant='primary'
      footerPrimaryActionLoading={removingAllocationContextUser || polling}
      onFooterSecondaryAction={onCancel}
      centered={true}
    />
  )
}
